import React from 'react';
import { GridItem } from 'src/components/common/grids';
import Modal from 'src/components/common/modal/Modal';
import { BoldText, Pmodal } from '../../styles';
import { useMigrateTab } from './useMigrateTab';
import MigrateStatusSelect from '../PropertyTables/MigrateStatusSelect';
import PropertiesSummary from '../PropertyTables/PropertiesSummary';


interface MigrateTabProps {
    columnHeaders: Array<{ key: string, label: string, value: string }>;
    type: string;
    emailContact?: string;
    summaryByEmailContact?: [];
    activeTab?: number;
    mainLoadingSummary?: boolean;
    bannedUsers?: []
}

const MigrateTab = ({
    columnHeaders, 
    type, 
    emailContact, 
    summaryByEmailContact, 
    activeTab,
    mainLoadingSummary,
    bannedUsers
}: MigrateTabProps) => { 

    const {
        summary,
        stateToMigrate,
        setStateToMigrate,
        loadingSummary,
        showModal,
        modalMessage,
        onCloseModal,
        userSummary,
        emailContactSummary,
    } = useMigrateTab(type, emailContact, summaryByEmailContact, activeTab, bannedUsers);
    
    return (
        <>
            {
                activeTab !== 6 && (
                    <>
                        <BoldText>Resúmen</BoldText>
                        {
                            summary && (
                                
                                <GridItem sm={4} md={6} lg={8}>
                                    <MigrateStatusSelect
                                        value={stateToMigrate}
                                        setValue={setStateToMigrate}
                                        text={"Migrar activos"}
                                        buttonSelect={false}
                                        handler={null}
                                        loadingMigration={null}
                                        />
                                </GridItem>
                            )
                        }
                    </>
                )
            }
            <PropertiesSummary
                summary={summary}
                columnsHeader={columnHeaders}
                loadingSummary={loadingSummary || mainLoadingSummary}
                handleExtend15Days={null}
                handleExtend30Days={null}
                email={userSummary.values.email}
                emailContactSummary={emailContactSummary}
                activeTab={activeTab}
            />
            {showModal && (
                <Modal onClose={onCloseModal}>
                    <div>
                        <img src="/images/logo-propiedades.svg" alt="logo propiedades" />
                    </div>
                    {modalMessage ? <Pmodal>{modalMessage}</Pmodal> : <p></p>}
                </Modal>
            )}
        </>
    )
}

export default MigrateTab;